<template>
  <section class="section" id="campos">
    <institution-form></institution-form>
  </section>
</template>

<script>
import InstitutionForm from '@/components/admin/institutions/InstitutionsForm.vue'

export default {
  components: { InstitutionForm },
  data() {
    return {}
  },
  methods: {},
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm(this.$t('¿Estás seguro de querer salir?'))
    if (answer) {
      next()
    } else {
      next(false)
    }
  }
}
</script>

<style></style>
